import LocalizedStrings from 'localized-strings';

const locales = new LocalizedStrings({
  en: {
    cta: {
      restart: 'Restart from scratch',
      resume: 'Continue',
    },
    description:
      'Last time you left us, you were creating an account for this company:',
    prompt: 'What would you like to do?',
    registrationDateLabel: 'Registration Date',
    siretLabel: 'SIRET',
    title: {
      withName: 'Happy to see you, {name}!',
      withoutName: 'Happy to see you!',
    },
  },

  fr: {
    cta: {
      restart: 'Repartir de zéro',
      resume: 'Continuer',
    },
    description:
      'La dernière fois que vous nous aviez quitté, vous étiez en pleine création de votre compte pour la société suivante\u00A0:',
    prompt: 'Que souhaitez-vous faire\u00A0?',
    registrationDateLabel: 'Date de création',
    siretLabel: 'SIRET',
    title: {
      withName: 'Heureux de vous revoir {name}\u00A0!',
      withoutName: 'Heureux de vous revoir\u00A0!',
    },
  },
} as const);

export default locales;
